const AWSConfig = {
  IDENTITY_POOL_ID: 'us-east-1:8f844ccb-ce6e-48d4-a65e-0ffb145b39bb',
  LOGIN_KEY: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_JUoovTVPK',
  BUCKET: 'urlrecategorization',
};
export default AWSConfig;
